/** API route map: URLS.Controller.CandidateAttachment */
export const CandidateAttachment = {
      Name: 'CandidateAttachment/',
      GetAll: 'candidate-attachments',
      Add: 'add',
      DeleteAttachment: 'delete',
};
